export default "__VITE_ASSET__CzCTLPix__"